/**
 * İŞLEMSEL E-POSTA KATALOĞU (Story 9.1) — şablon anahtarları + teslimat durumu.
 *
 * `enums.ts`TEN AYRILDI (05.09.2026): katalog 25 anahtara ve uzun gerekçelere
 * ulaştı, barelin okunurluğunu bastırıyordu. Tüketiciler `@icebreaker/shared`
 * barelinden aldığı için taşıma hiçbir çağıranı değiştirmez; `enum-parity`
 * kapısı `domain/` klasörünü ÖZYİNELEMELİ tarar, yani sınıflandırma denetimi
 * de aynen sürer.
 */
export const EMAIL_DELIVERY_STATUSES = ['queued', 'sent', 'failed', 'dead'];
export const EMAIL_TEMPLATE_KEYS = [
    'otp_login',
    'registration_confirmed',
    'event_invitation',
    'application_result',
    'event_updated',
    'event_cancelled',
    'team_invitation',
    'claim_owner_notice',
    'claim_decision',
    'claim_transferred',
    'claim_info_request',
    'data_export_ready',
    'account_deletion_confirmed',
    'speaker_link_request',
    /** Süresi dolmuş davet için katılımcının organizatörden yeni davet istemesi (ekran G3). */
    'invitation_request',
    /**
     * Görüşme talebi yaşam döngüsü (Blok 12 — Story 14.1). DÖRT olay, dört şablon.
     * KIRMIZI ÇİZGİ: gövde gönderenin adı + etkinlik + süreyi taşır; talebin
     * SERBEST METNİ (mesaj) ASLA taşınmaz — uygulamada okunur.
     */
    'meeting_request_received',
    'meeting_request_accepted',
    'meeting_request_declined',
    'meeting_request_cancelled',
    /**
     * Kurum doğrulama kararı (Karar 1 · Story 18.4). TEK şablon iki sonucu taşır;
     * red gerekçesi başvurana AYNEN gösterilir (parametre `reason`).
     */
    'organization_verification_decision',
    /**
     * Kart degisimi TAMAMLANDI (Blok 21). TEK e-posta sablonu vardir: teklif
     * bildirimi yalniz push'tur (15 dakikalik pencereye e-posta yetismez) ve
     * ret/iptal/sure dolumu HIC bildirilmez. Govde karsi tarafin ADINI tasir —
     * o ad zaten iki tarafin da onayladigi kartin uzerindedir; kartin ILETISIM
     * alanlari (e-posta, telefon, URL) sablona GIRMEZ.
     */
    'card_exchange_confirmed',
    /**
     * Takip hatirlatmasi (Blok 23). GOVDEDE KULLANICININ KENDI NOTU YOKTUR (D6):
     * yalniz karsi tarafin adi ve derin baglanti tasinir. Sablon KAPATILABILIR
     * ture baglidir (`follow_up_reminder`).
     */
    'follow_up_reminder',
    /**
     * PERSONEL KİMLİĞİ (panel kimliği ayrımı · S1). İkisi de `staff_accounts`
     * yüzeyine aittir ve ürün adreslerine HİÇ gitmez; katalog paylaşılır çünkü
     * gönderim altyapısı (`MailModule`) Karar 7'de "paylaşılır" sayılmıştır.
     */
    'staff_login_code',
    'staff_invitation',
    // ÜRÜN ŞİFRESİ (05.09.2026): üçü de `otp_login`DAN AYRI amaçtır; "zaten
    // hesabın var" gövdesinde KOD YOKTUR (K10 — sayım posta kutusuna taşınmaz).
    'email_verification',
    'password_reset',
    'account_exists_notice',
    /**
     * Etkinlik katılımcı tavanının %80'i (V18-c, kullanıcı kararı 01.10.2026):
     * kurum sahibine ve yayın yetkili yöneticilere etkinlik başına BİR kez gider.
     * Gövde yalnız etkinlik adı + sayı + tavan taşır; katılımcı PII'si YOK.
     */
    'event_ceiling_warning',
    /**
     * Organizatör duyurusu (Story 1). Gövde ORGANİZATÖRÜN serbest metnidir; düz
     * metin olarak işlenir (HTML kaçışlanır). Alıcı adresi kuruma GİTMEZ, gönderim
     * platformdan çıkar.
     * TODO(tech-debt): tek tık ret bağlantısı ve `List-Unsubscribe` başlığı Story 2
     * (T2a) işidir; o tur birleşmeden bu şablon canlıda gönderilmemelidir.
     */
    'organizer_announcement',
    /**
     * "Rapor hazır" (organizatör raporu Story 4, 26.10.2026): etkinlik sonu raporu
     * dondurulunca kurumun `owner` ve `admin` hesaplarına kişi başı BİR kez. Gövde
     * yalnız etkinlik adı ve raporun toplu sayılarını taşır; kişi verisi YOK.
     * İşlemseldir (kapatılabilir türe bağlı değil), `event_ceiling_warning` emsali.
     */
    'event_report_ready',
    /**
     * Etkinlik sonrası iletisi (belge ve anket Story 6): bitiş + 2 sa, check-in yapmış
     * katılımcıya etkinlik başına BİR kez. Belge ve anket bağlantısı etkinliğin durumuna
     * göre çizilir. Kapatılabilir türe bağlıdır (`event_reminder`).
     */
    'post_event_message',
    /**
     * Etkinlik hatırlatması (hatırlatma ve önerilen kişiler Story 1 + 2): başlangıçtan 24 sa
     * önce kesin kayıtlıya etkinlik başına BİR kez. "Tanışman gereken kişiler" bloğu en çok
     * 3 kişinin adını, unvan · şirket satırını ve gerekçe cümlesini taşır; fotoğraf, e-posta,
     * telefon ve bağlantı adresi TAŞIMAZ (şablon kapısı). Kapatılabilir türe bağlıdır
     * (`event_reminder`).
     */
    'event_reminder',
];
/**
 * SES GERİ BİLDİRİMİ (organizatör duyuruları Story 9). SNS üzerinden gelen
 * geri dönme ve şikâyet olayları. Kalıcı geri dönme (`permanent`) ve şikâyet
 * adresi duyuru alıcılığından düşürür; geçici geri dönme yalnız kaydedilir.
 * İşlemsel e-posta (giriş kodu dahil) bu olaylardan HİÇ etkilenmez.
 */
export const EMAIL_FEEDBACK_KINDS = ['bounce', 'complaint'];
export const EMAIL_BOUNCE_TYPES = ['permanent', 'transient', 'undetermined'];
//# sourceMappingURL=email-templates.js.map